import {SET_HAD_LOGIN_SESSION, SET_WAS_OFFLINE, SET_WAS_DONATE_POPUP, SET_WAS_ASKED_TUTORIAL} from "../../modules/app"
import {setLocalAppData} from "../../helpers/localData"


const localData = store => next => action => {
    switch (action.type) {
        case SET_HAD_LOGIN_SESSION : {
            let {hadLoginSession} = action.payload
            setLocalAppData({hadLoginSession})
            break
        }
        case SET_WAS_OFFLINE : {
            let {wasOffline} = action.payload
            setLocalAppData({wasOffline})
            break
        }
        case SET_WAS_DONATE_POPUP : {
            let {wasDonatePopup} = action.payload
            setLocalAppData({wasDonatePopup})
            break
        }
        case SET_WAS_ASKED_TUTORIAL : {
            let {wasAskedTutorial} = action.payload
            setLocalAppData({wasAskedTutorial})
            break
        }
    }
    next(action)
}

export default localData


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/redux/middlewares/localData.js